export default {
  messages: {
    maxFileSize: 'O tamanho do ficheiro deve ser igual ou inferior a {1} Mb.',
    totalFileSize: 'O tamanho total dos ficheiros deve ser igual ou inferior a 8 Mb.',
    fileType: 'Formato de ficheiro inválido. O ficheiro deve ser {1}.',
    maxAmount: 'O valor de {0} excede o máximo permitido (99.999.999,00).',
    table: 'A tabela {0} deve conter pelo menos 1 elemento.',
    detailsTable: 'Para continuar, deve adicionar pelo menos uma linha de detalhe',
    taxesTable: 'A tabela de Impostos deve conter pelo menos 1 elemento',
    deliveryNotesTable: 'A tabela de Albarán deve conter pelo menos 1 elemento',
    taxesTypes: 'Os impostos introduzidos não podem ser do mesmo tipo',
    cifNotProvider: 'Os CIF do emissor e receptor não podem ser iguais',
    dateFromSubscription: 'Não é permitido filtrar em uma conta gratuita por data anterior a três meses do dia de hoje',
    clientEmailRequired: 'O campo de Email do cliente é obrigatório.',
    clientEmailInvalid: 'O Email do cliente não é válido.',
    notSupportedNumber: 'O número introduzido não pode coincidir com o ID da fatura',
    validFileName: 'O nome do ficheiro contém caracteres não permitidos. Apenas são permitidas letras, números, espaços, pontos, hífens, sublinhados e parênteses.'
  }
}
